export default __webpack_public_path__ + "static/media/widget-button-preview.d3ceff19.svg";